<template>
  <v-card height="100%" elevation="9" class="d-flex flex-column">
    <v-card-title :id="titleId">{{ option.name }}</v-card-title>
    <v-card-text class="flex-grow-1">{{ option.help }}</v-card-text>

    <!-- Boolean option -->
    <v-card-actions v-if="option.type === 'bool'" class="align-center justify-center mt-auto" style="min-height: 72px;">
      <v-switch
        :model-value="option.value"
        @update:model-value="updateValue"
        :id="option.name"
        :aria-labelledby="titleId"
        class="align-center justify-center"
        hide-details
        inset
        color="primary"
      />
    </v-card-actions>

    <!-- Float option -->
    <v-card-actions v-else-if="option.type === 'float'" class="mt-auto" style="min-height: 72px;">
      <v-slider
        :model-value="option.value"
        @update:model-value="updateValue"
        :min="option.min"
        :max="option.max"
        :id="option.name"
        :aria-labelledby="titleId"
        :step="option.step"
      >
        <template v-slot:append>
          <v-text-field
            :model-value="option.value"
            @update:model-value="updateValue"
            :aria-labelledby="titleId"
            class="mt-0 pt-0"
            hide-details
            single-line
            type="number"
            variant="outlined"
            style="width: 85px"
          />
        </template>
      </v-slider>
    </v-card-actions>

    <!-- Choice option -->
    <v-card-actions v-else-if="option.type === 'choice'" class="mt-auto" style="min-height: 72px;">
      <v-select
        :model-value="option.value"
        @update:model-value="updateValue"
        :name="option.name"
        :id="option.name"
        :aria-labelledby="titleId"
        :items="option.choices"
      />
    </v-card-actions>

    <!-- Multi-choice option -->
    <v-card-actions v-else-if="option.type === 'multi-choice'" class="mt-auto" style="min-height: 72px;">
      <v-select
        :model-value="option.value"
        @update:model-value="updateValue"
        :name="option.name"
        :id="option.name"
        :aria-labelledby="titleId"
        :items="option.choices"
        multiple
      />
    </v-card-actions>

    <!-- Color option -->
    <v-card-actions class="align-center justify-center mt-auto" v-else-if="option.type === 'color'" style="min-height: 72px;">
      <v-color-picker
        hide-canvas
        :model-value="option.value"
        @update:model-value="updateValue"
        :id="option.name"
        :aria-labelledby="titleId"
        role="group"
      />
    </v-card-actions>

    <!-- Unsupported option -->
    <v-card-actions v-else class="mt-auto" style="min-height: 72px;">
      <p>Option type not supported...</p>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'OptionCard',
  props: {
    option: Object
  },
  emits: ['update:option'],
  computed: {
    titleId() {
      return `${this.option.name}-label`
    }
  },
  methods: {
    updateValue(newValue) {
      this.$emit('update:option', { ...this.option, value: newValue })
    }
  }
}
</script>
